import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskGettingStartedSlaViewRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-sla-view',
	path: '/jira/servicedesk/projects/:projectKey/getting-started/sla/custom/:id',
	exact: true,
};
